import React from "react";
import Icon from "../../../../components/Icon";

export function SubnetProfileDrawer({
  subnet,
  onClose,
  assets = [],
  subnets = [],
}) {
  if (!subnet) return null;

  const detectedHosts = assets.filter(
    (a) =>
      a.subnet_id === subnet.id ||
      subnet.subnet === subnets.find((s) => s.id === a.subnet_id)?.subnet,
  );

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(15, 23, 42, 0.15)",
          backdropFilter: "blur(1px)",
          zIndex: 1050,
        }}
      />
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          width: 460,
          background: "#fff",
          borderLeft: "1px solid #E5E7EB",
          boxShadow: "-10px 0 30px rgba(0,0,0,0.08)",
          zIndex: 1100,
          display: "flex",
          flexDirection: "column",
          padding: 24,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
            borderBottom: "1px solid #F3F4F6",
            paddingBottom: 12,
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: 16,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            Subnet Profile
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 4,
            }}
          >
            <Icon name="x" size={18} color="#6B7280" />
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              CIDR Block
            </span>
            <div
              style={{
                fontSize: 15,
                fontWeight: 700,
                fontFamily: "monospace",
                color: "#111827",
                marginTop: 2,
              }}
            >
              {subnet.subnet}
            </div>
          </div>

          <div>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              Description
            </span>
            <div style={{ fontSize: 13, color: "#374151", marginTop: 2 }}>
              {subnet.name}
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
            }}
          >
            <div>
              <span
                style={{
                  fontSize: 11,
                  color: "#6B7280",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                Status
              </span>
              <div style={{ fontSize: 13, color: "#374151", marginTop: 2 }}>
                {subnet.status}
              </div>
            </div>
            <div>
              <span
                style={{
                  fontSize: 11,
                  color: "#6B7280",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                Last Scanned
              </span>
              <div
                style={{
                  fontSize: 13,
                  color: "#374151",
                  fontFamily: "monospace",
                  marginTop: 2,
                }}
              >
                {subnet.lastScan}
              </div>
            </div>
          </div>

          {/* Subnet Hosts */}
          <div style={{ marginTop: 12 }}>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
                display: "block",
                marginBottom: 8,
              }}
            >
              Detected Hosts ({detectedHosts.length})
            </span>
            <div
              className="premium-table-container"
              style={{
                maxHeight: 220,
                overflowY: "auto",
                marginBottom: 0,
              }}
            >
              <table className="premium-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>IP</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {detectedHosts.map((host) => (
                    <tr key={host.id}>
                      <td style={{ fontWeight: 600 }}>
                        {host.name}
                      </td>
                      <td style={{ fontFamily: "monospace" }}>
                        {host.ip}
                      </td>
                      <td>
                        {host.status}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubnetProfileDrawer;
